export const STATE_NAME = 'featureFlags';

export const Actions = {
  FETCH_FEATURE_FLAGS: `${STATE_NAME}/FETCH_FEATURE_FLAGS`,
  FETCH_FEATURE_FLAGS_SUCCESS: `${STATE_NAME}/FETCH_FEATURE_FLAGS_SUCCESS`,
  FETCH_FEATURE_FLAGS_FAIL: `${STATE_NAME}/FETCH_FEATURE_FLAGS_FAIL`,

  SET_FEATURES: `${STATE_NAME}/SET_FEATURES`,
};
